export enum NeuteredCodeEnum {
  Neutered = 'neutered',
  NotNeutered = 'not neutered',
  Unknown = 'unknown',
}
